
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AuthService from "../../services/auth.service";
import CommonOtp from "../../components/otp-pre-login";

export default function ForceChangeOTP() {
    const [otp, setOtp] = useState("");
    const location = useLocation();
    const [formValues, setFormValues] = useState({});
    const navigate = useNavigate();
    const [message, setMessage] = useState("");
    const [successVisible, setSuccessVisible] = useState(false);

    useEffect(() => {
        if (!location.state) {
          navigate("/login");
        } else {
          setFormValues(location.state || "");
        }
      }, []);


    const forceChangePasswordConfirm = useCallback(async (values) => {
        try {
            const response = await AuthService.forceChangePasswordConfirm({
                newPassword: formValues?.newPassword,
                currentPassword: formValues.password,
                otp: values.otp,
            });
            if (response.status === 200) {
                setMessage(response.data["message"]);
                setSuccessVisible(true);
            }
        } catch (error) {
            setOtp("");
        }
    }, [formValues]);

    const onConfirm = useCallback(
        async (values) => {
            try {
                await forceChangePasswordConfirm({ ...formValues, ...values });
            } catch (error) {
                setOtp("");
            }
        },
        [formValues]
    );

    const handleResendOtp = useCallback(async () => {
        setOtp("");
        const response = await AuthService.forceChangePasswordVerify({
            newPassword: formValues?.newPassword,
            currentPassword: formValues.password,
        });
        if (response.status === 200) {
        }
    }, [formValues]);


    return (
        <>
            <CommonOtp
                otp={otp}
                setOtp={setOtp}
                type="TRANSACTION"
                onConfirm={() =>
                    onConfirm({ ...formValues, otp: otp })
                }
                handleResendOtp={() => handleResendOtp()}
                cancelTransaction={() => {
                    navigate("/login");
                }}
                bankLogo={BANK_LOGO}
                verifyDetails={formValues}
                successVisible={successVisible}
                message={message}
                routingURL={"/login"}
            />
        </>
    );
}